import IComponent from "components/commons/IComponent";
import Slider from "@material-ui/core/Slider";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./LayerSetting.scoped.css";

class OpacitySlider extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  render() {
    let layer = this.props.layer || { opacity: 0, disabled: true };
    let darkMode = this.props.darkMode;
    return (
      <div
        className={`LayerOpacityBar SubPanelContent ${
          layer.disabled ? "OpacityDisable" : ""
        } ${darkMode ? "darkMode" : ""}`}
      >
        <div className="TextDIV">
          <div className="TextDIV">Opacity</div>
          <EditableDatagridCell
            style={{
              width: "60px",
            }}
            cellInfo={{
              colDef: {
                field: "v",
                dataType: "text",
              },
              row: { v: Math.round(layer.opacity * 100) },
            }}
            onChange={(a, nV, nVs) => {
              layer.opacity = nV / 100;
              this.props.onChange && this.props.onChange(layer.opacity);
              this.setState({});
            }}
          />
        </div>
        <Slider
          value={layer.opacity * 100}
          onChange={(e, nV) => {
            layer.opacity = nV / 100;
            this.props.onChange && this.props.onChange(layer.opacity);
            this.setState({});
          }}
          style={{ zoom: "125%" }}
        />
      </div>
    );
  }
}

export default OpacitySlider;
